import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { cx } from '../cx';

// D-09 §15.45 — QR 코드 카드.
// 셸 규격은 §15.17 드롭존과 같은 값이고 보더만 solid 다(QR 은 드롭 대상이 아니다).
// 표시 전용 — 타이머·SSE·발급 로직은 소비처가 소유한다.
export interface QrCardProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  /** QR 에 실을 값. children 을 주면 QR 대신 그것을 그리므로 생략 가능 */
  value?: string;
  title?: React.ReactNode;
  /** QR 위 보조 안내 */
  subtitle?: React.ReactNode;
  /** QR 아래 안내 */
  description?: React.ReactNode;
  /** 안내문(보조색) → 행동 지시문(강조) */
  descriptionStrong?: boolean;
  /** 캡션 줄 — 타이머·만료 문구 */
  caption?: React.ReactNode;
  captionTone?: 'hint' | 'danger';
  /** QR blur + 오버레이 노출 */
  expired?: boolean;
  /** 만료 시 프레임 중앙 액션(재발급 버튼 등) */
  overlay?: React.ReactNode;
  /** QR 한 변(px). 160 미만은 인식률이 떨어진다(§15.45 Don't) */
  size?: number;
  /** 주면 QR 대신 이 내용을 그린다 — 인계·완료 상태 */
  children?: React.ReactNode;
}

export function QrCard({
  value,
  title,
  subtitle,
  description,
  descriptionStrong = false,
  caption,
  captionTone = 'hint',
  expired = false,
  overlay,
  size = 160,
  className = '',
  children,
  ...props
}: QrCardProps) {
  const head = title != null || subtitle != null;
  const foot = description != null || caption != null;

  return (
    <div className={cx('qr-card', className)} {...props}>
      {head && (
        <div className="qr-text">
          {title != null && <div className="qr-title">{title}</div>}
          {subtitle != null && <div className="qr-desc">{subtitle}</div>}
        </div>
      )}

      {children ?? (
        value != null && (
          <div className={cx('qr-frame', expired && 'is-expired')}>
            <QRCodeSVG value={value} size={size} level="M" />
            {expired && overlay != null && <div className="qr-overlay">{overlay}</div>}
          </div>
        )
      )}

      {foot && (
        <div className="qr-text">
          {description != null && (
            <div className={cx('qr-desc', descriptionStrong && 'is-strong')}>{description}</div>
          )}
          {caption != null && (
            <div className={cx('qr-caption', captionTone === 'danger' && 'is-danger')}>{caption}</div>
          )}
        </div>
      )}
    </div>
  );
}
